module.exports = __webpack_public_path__ + "static/azul_small_logo-f77066e75257504243094b10c5f5e543.svg";